import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** A component, not a bare Navigate, so it can interpolate `:testId` and carry the section `#hash`. */
export const SettingsRedirect: React.FC<{ hash: string }> = ({ hash }) => {
  const { testId } = useParams<{ testId: string }>();
  return <Navigate to={`/app/tests/${testId}/settings#${hash}`} replace />;
};

export default SettingsRedirect;
